import type { CallbackEvent } from "@shopify/polaris-types";
import {
  CollapsibleSectionCard,
  SectionHeader,
  ColorRow,
  NumericField,
} from "../../../components/shared/EditorShared";

// ─── Section 5: Design ────────────────────────────────────────────────────────

export function DesignSection({
  titleOverride,
  description,
  imageUrl,
  backgroundColor,
  borderColor,
  activeBorderColor,
  borderRadius,
  onTitleOverrideChange,
  onDescriptionChange,
  onImageUrlChange,
  onBackgroundColorChange,
  onBorderColorChange,
  onActiveBorderColorChange,
  onBorderRadiusChange,
}: {
  titleOverride: string;
  description: string;
  imageUrl: string;
  backgroundColor: string;
  borderColor: string;
  activeBorderColor: string;
  borderRadius: number;
  onTitleOverrideChange: (v: string) => void;
  onDescriptionChange: (v: string) => void;
  onImageUrlChange: (v: string) => void;
  onBackgroundColorChange: (v: string) => void;
  onBorderColorChange: (v: string) => void;
  onActiveBorderColorChange: (v: string) => void;
  onBorderRadiusChange: (v: number) => void;
}) {
  return (
    <CollapsibleSectionCard
      header={<SectionHeader number={6} title="Apariencia" />}
    >
      <s-stack direction="block" gap="base">
        <s-text color="subdued">
          Personaliza cómo se ve el bundle en el formulario.
        </s-text>

        <s-text-field
          label="Título (opcional)"
          placeholder="Ej. Bundle & Save"
          value={titleOverride}
          onInput={(e: CallbackEvent<"s-text-field">) =>
            onTitleOverrideChange(e.currentTarget.value)
          }
        />

        <s-text-field
          label="Descripción (opcional)"
          placeholder="Ej. The more you buy, the more you save"
          value={description}
          onInput={(e: CallbackEvent<"s-text-field">) =>
            onDescriptionChange(e.currentTarget.value)
          }
        />

        <s-text-field
          label="URL de imagen de portada (opcional)"
          placeholder="https://..."
          value={imageUrl}
          onInput={(e: CallbackEvent<"s-text-field">) =>
            onImageUrlChange(e.currentTarget.value)
          }
        />

        <ColorRow
          label="Color de fondo"
          value={backgroundColor}
          onChange={onBackgroundColorChange}
        />

        <ColorRow
          label="Color de borde"
          value={borderColor}
          onChange={onBorderColorChange}
        />

        <ColorRow
          label="Color de borde al seleccionar"
          value={activeBorderColor}
          onChange={onActiveBorderColorChange}
        />

        <NumericField
          label="Radio del borde (px)"
          value={borderRadius}
          min={0}
          max={40}
          onChange={onBorderRadiusChange}
        />
      </s-stack>
    </CollapsibleSectionCard>
  );
}
